var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:_vm.rootClass},[_c('a-progress',{attrs:{"percent":_vm.percent,"show-info":false,"size":"small"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }